export default [
  {value: 1, name: '设备类别'},
  {value: 2, name: '设备型号'},
  {value: 3, name: '电梯品牌'},
  {value: 4, name: '电梯场所'},
  {value: 5, name: '房地产'},
  {value: 6, name: '生产制造厂家'},
  {value: 7, name: '物业品牌'},
  {value: 8, name: '小区'},
]